const sendHttpPutRequest = (url, data) => {
  return fetch(url, {
    method: "put",
    body: data,
    headers: data
      ? {
          "Content-Type": "application/json",
        }
      : {},
  }).then((response) => {
    if (response.status >= 400) {
      return response.json().then((errResData) => {
        const error = new Error(`Something went wrong! ${errResData}`);
        error.data = errResData;
        throw error;
      });
    }
    return response.json().then((data) => data);
  });
};

export default sendHttpPutRequest;
